import { AuthenticatedRoute } from "@components/AuthenticatedRoute";
import { AdminShell } from "@fadmin/components/AdminShell";
import { GoBack } from "@fadmin/components/GoBack";
import { NavItems } from "@helpers/navigation";
import { RoleId } from "@store/generalTypes";
import { Route, Routes, useLocation, useNavigate } from "react-router";
import { SuperNav } from "../components/superNav";
import { CreateOrganization } from "./createOrganization";
import { SuperOrganizations } from "./organizations";
import SuperOrganizationDetails from "./superOrganizationDetails";
import { WordSuggestions } from "./wordSuggestions";

export const SuperAdminLanding = (): JSX.Element => {
    const { pathname } = useLocation();
    const navigate = useNavigate();

    const handleGoBack = (): void => {
        navigate(NavItems.SuperAdmin.Organizations.path);
    };

    const routes = (
        // NOTE: Clinician role is temporary, will change to Super later
        <AuthenticatedRoute roles={[RoleId.SuperAdmin]} autoRedirect={false}>
            <Routes>
                <Route path="*" element={<SuperOrganizations />} />
                <Route path={NavItems.SuperAdmin.Organizations.relativePath} element={<SuperOrganizations />} />
                <Route
                    path={NavItems.SuperAdmin.OrganizationDetails.relativePath + ":id"}
                    element={<SuperOrganizationDetails />}
                />
                <Route path={NavItems.SuperAdmin.CreateOrganization.relativePath} element={<CreateOrganization />} />
                <Route path={NavItems.SuperAdmin.WordSuggestions.relativePath} element={<WordSuggestions />} />
            </Routes>
        </AuthenticatedRoute>
    );
    return (
        <AdminShell
            routes={routes}
            nav={
                pathname.includes(NavItems.SuperAdmin.CreateOrganization.relativePath) ? (
                    <GoBack onClick={handleGoBack} title="Back to All Organizations" />
                ) : (
                    <SuperNav />
                )
            }
        />
    );
};
